import { isSuccess } from '@/context/services/type';
import { useCopyInvoiceReport as useBaseCopyInvoiceReport } from 'ap-openapi';
import { useCallback } from 'react';

export const useCopyInvoiceReportService = () => {
  const { mutateAsync: _mutateAsync } = useBaseCopyInvoiceReport();

  const mutateAsync = useCallback(
    async (
      id: string,
      shareWithSameViewers?: boolean
    ): Promise<{ editPath: string | undefined }> => {
      const resp = await _mutateAsync({
        id,
        data: { share_with_same_viewers: shareWithSameViewers },
      });
      if (!isSuccess(resp.status)) {
        const errorData =
          typeof resp.data === 'object' && resp.data !== null ? resp.data : {};
        throw { ...errorData, statusCode: resp.status };
      }
      return { editPath: resp.data?.edit_path };
    },
    [_mutateAsync]
  );

  return { mutateAsync };
};
